import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border border-brand-charcoal rounded-xl bg-brand-slate/30 overflow-hidden" data-id="element-35">
      <button onClick={onClick} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-36">
        <span className="text-lg font-bold text-brand-cream pr-4" data-id="element-37">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0 text-brand-gold" data-id="element-38">
          <ChevronDown className="w-5 h-5" data-id="element-39" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-40">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-41">
            <div className="px-6 pb-5 text-brand-gray" data-id="element-42">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Realmente funciona si mi hijo es muy rebelde?',
    a: 'Sí, porque el método no depende de su voluntad, sino de tu cambio de patrón. Al cambiar el estímulo (tu reacción), fuerzas biológicamente una respuesta diferente en él.'
  }, {
    q: '¿Es difícil de leer o muy largo?',
    a: "No, está diseñado específicamente para madres ocupadas y agotadas. Puedes leerlo completo en una sola tarde y empezar a aplicar la 'Gramática de Emergencia' en la cena de hoy mismo."
  }, {
    q: '¿Tengo que castigarlo mucho para que funcione?',
    a: 'Al contrario. Aprenderás a usar consecuencias naturales que duelen más que cualquier castigo impuesto, y lo más importante: no te desgastan emocionalmente a ti.'
  }];
  return <section className="py-24 px-4 bg-brand-navy" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <FadeIn data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-46">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-48">
              <FAQItem question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-49" />
            </FadeIn>)}
        </div>
      </div>
    </section>;
}